import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/contracts',
  title: 'Contracts',
  endpoint: '/app/professional/contracts',
  breadcrumbs: [{ label: '', location: '' }],
}
